module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/back-wifi-03f96dadaad9a5b586a77619406be252.jpg";